<template>
  <footer class="app-footer">
    <span class="ml-auto">FATOS ADMIN <a href="http://www.fatoscorp.com">© 2018 fatoscorp.com</a></span>
  </footer>
</template>
<script>
export default {
  name: 'c-footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue